module.exports = __webpack_public_path__ + "img/容城服装.0d2c9351.jpg";